import styled from 'styled-components';
import { deviceSizes } from '../../../../config/devices';
export var CardContainer = styled.div.withConfig({
  displayName: "style__CardContainer",
  componentId: "sc-hq9bsp-0"
})(["padding-right:0.5rem;padding-left:0.5rem;height:100%;padding-bottom:10px;@media (max-width:", "){padding-right:4rem;padding-left:4rem;}@media (max-width:", "){padding-right:2rem;padding-left:2rem;}"], deviceSizes.sm, deviceSizes.mobileL);
export var SliderContainer = styled.div.withConfig({
  displayName: "style__SliderContainer",
  componentId: "sc-hq9bsp-1"
})(["@media (max-width:", "){padding-top:2rem;}"], deviceSizes.mobileL);

// export const useClasses = makeStyles({
//   CardContainerStyle: {
//     paddingRight: '4.5rem',
//     paddingLeft: '4.5rem',
//     height: '100%',
//     [`@media only screen and (min-width: ${deviceSizes.tablet}) and (max-width: ${deviceSizes.md}) `]: {
//       paddingRight: '12rem',
//       paddingLeft: '12rem',
//     },

//     [`@media only screen and (min-width: ${deviceSizes.mobileL}) and (max-width: ${deviceSizes.sm})`]: {
//       paddingRight: '1rem',
//       paddingLeft: '1rem',
//     },

//     [`@media (max-width: ${deviceSizes.mobileL})`]: {
//       paddingRight: '0',
//       paddingLeft: '0',
//     },
//   },
// });